import { useTranslation } from "react-i18next";

import {
  Anchor,
  Card,
  Center,
  Container,
  Stack,
  Text,
  Title,
} from "@mantine/core";

export function Food() {
  const { t } = useTranslation();
  return (
    <Container size="md">
      <Stack gap="lg" align="center" ta="center">
        <Title order={1}>{t("menu.stay.food")}</Title>
        <Text c="dimmed" maw={620}>
          A short stroll from the villa, our friends at Santa Marina serve up
          authentic Cretan cooking with a sea-view setting. Tell them
          you&apos;re staying at Villa Braou.
        </Text>
        <Card withBorder p="xl" w="100%" maw={420}>
          <Anchor
            href="https://www.santamarina-creta.gr/"
            target="_blank"
            rel="noopener noreferrer"
            underline="never"
          >
            <Center>
              <img
                src="https://images.squarespace-cdn.com/content/v1/66f16a7fb0e5fe3799d081ac/501c8523-02d9-48f9-8af4-faeb3ad2194e/logo+2.png?format=1500w"
                alt="Santa Marina"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </Center>
          </Anchor>
        </Card>
      </Stack>
    </Container>
  );
}

export default Food;
